var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockButtonFilter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5962 19.6575C11.7525 19.8837 10.8813 20 10 20C4.48625 20 0 15.5138 0 10C0 4.48625 4.48625 0 10 0C15.5138 0 20 4.48625 20 10C20 10.8813 19.885 11.7537 19.6588 12.5962C19.4025 12.3212 19.1175 12.075 18.8062 11.8625C18.935 11.2525 19.0012 10.6287 19.0012 9.99875C19.0012 5.03625 14.9638 0.99875 10.0013 0.99875C5.03875 0.99875 1 5.0375 1 10C1 14.9625 5.0375 19 10 19C10.63 19 11.2538 18.935 11.8638 18.8062C12.0763 19.1175 12.3212 19.4025 12.5962 19.6575ZM15 9.5H10.5V3.5H9.5V10.5H15V9.5ZM16.0075 17C15.7262 17 15.5 17.2237 15.5 17.5C15.5 17.7812 15.7213 18 16.0025 18C16.2788 18 16.5 17.7763 16.5 17.5C16.5 17.2288 16.2738 17 16.0075 17ZM15.6588 16.5H16.3412L16.5 15.005V14H15.5V14.995L15.6588 16.5ZM20 16C20 13.7937 18.2062 12 16 12C13.7937 12 12 13.7937 12 16C12 18.2062 13.7937 20 16 20C18.2062 20 20 18.2062 20 16ZM19 16C19 17.6537 17.6537 19 16 19C14.3463 19 13 17.6537 13 16C13 14.3463 14.3463 13 16 13C17.6537 13 19 14.3463 19 16Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockButtonFilter);
export default __webpack_public_path__ + "static/media/clockButtonFilter.985c105f466cbfaacf4839126a2d3aa0.svg";
export { ForwardRef as ReactComponent };